import { render, staticRenderFns } from "./CreateEvent-v2.vue?vue&type=template&id=75bd5416&"
import script from "./CreateEvent-v2.vue?vue&type=script&lang=js&"
export * from "./CreateEvent-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports